import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

export default function Auth() {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signup, login } = useAuth();

    // --- NEW: State to manage the signup flow ---
    const [isJoiningFarm, setIsJoiningFarm] = useState(false);
    const [farmName, setFarmName] = useState('');
    const [joinFarmId, setJoinFarmId] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // --- NEW: Updated validation logic ---
        if (!isLogin) {
            if (isJoiningFarm && joinFarmId.trim() === '') {
                setError("Please enter the Farm ID to join.");
                return;
            }
            if (!isJoiningFarm && farmName.trim() === '') {
                setError("Please enter a name for your new farm.");
                return;
            }
        }

        setLoading(true);

        try {
            if (isLogin) {
                await login(email, password);
            } else {
                // --- NEW: Pass either the farmName or the joinFarmId to signup ---
                await signup(email, password, { farmName: isJoiningFarm ? null : farmName, joinFarmId: isJoiningFarm ? joinFarmId : null });
            }
        } catch (err) {
            setError(err.message.replace('Firebase: ', ''));
        }
        setLoading(false);
    };
    
    // Reset form state when switching between Login and Sign Up
    const toggleAuthMode = () => {
        setIsLogin(!isLogin);
        setError('');
        setFarmName('');
        setJoinFarmId('');
        setIsJoiningFarm(false);
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
            <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8">
                <h2 className="text-2xl font-bold text-center mb-6">{isLogin ? 'Log In' : 'Sign Up'}</h2>
                {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-4 text-sm">{error}</p>}
                
                <form onSubmit={handleSubmit}>
                    {/* --- NEW: Conditional UI for Sign Up --- */}
                    {!isLogin && (
                        <div className="mb-4 p-3 bg-gray-50 rounded-md">
                            <div className="flex justify-center space-x-4 mb-4">
                                <button type="button" onClick={() => setIsJoiningFarm(false)} className={`px-3 py-1 text-sm font-medium rounded-md ${!isJoiningFarm ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'}`}>Create New Farm</button>
                                <button type="button" onClick={() => setIsJoiningFarm(true)} className={`px-3 py-1 text-sm font-medium rounded-md ${isJoiningFarm ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'}`}>Join Existing Farm</button>
                            </div>

                            {isJoiningFarm ? (
                                <div>
                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="joinFarmId">Farm ID</label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="joinFarmId" type="text" placeholder="Enter the ID from the owner" value={joinFarmId} onChange={(e) => setJoinFarmId(e.target.value)} />
                                </div>
                            ) : (
                                <div>
                                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="farmName">New Farm Name</label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="farmName" type="text" placeholder="e.g., Green Valley Farms" value={farmName} onChange={(e) => setFarmName(e.target.value)} />
                                </div>
                            )}
                        </div>
                    )}

                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">Email Address</label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">Password</label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <div className="flex items-center justify-between">
                        <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full disabled:bg-indigo-300" type="submit" disabled={loading}>
                            {loading ? 'Processing...' : (isLogin ? 'Log In' : 'Sign Up')}
                        </button>
                    </div>
                </form>
                <p className="text-center text-gray-500 text-xs mt-6">
                    {isLogin ? "Don't have an account?" : 'Already have an account?'}
                    <button onClick={toggleAuthMode} className="font-bold text-indigo-600 hover:text-indigo-800 ml-1">
                        {isLogin ? 'Sign Up' : 'Log In'}
                    </button>
                </p>
            </div>
        </div>
    );
}
